/** Map axios/API errors to user-facing strings (shared by App and SleeperLookupPage). */
export function apiErrorMessage(err, { context = "request" } = {}) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (status === 401) return null;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (status === 429) return "Too many API requests — wait a minute, then try again.";
  if (status === 404 && context === "lookup" && detail === "Sleeper user not found") return "User not found";
  if (status === 404) {
    return "API 404 — wrong URL or missing Render rewrite. Either set REACT_APP_BACKEND_URL to https://your-backend.onrender.com (no /api), or use same-origin /api + Rewrite /api/* → backend.";
  }
  if (status === 502 || status === 503 || status === 504) {
    return "Backend is waking up or temporarily unavailable — try again in a few seconds.";
  }
  if (!status && err?.message === "Network Error") {
    return "Could not reach the API (network/adblock/VPN). Check your connection or try another browser.";
  }
  if (status) return `Request failed (HTTP ${status}).`;
  if (err?.code === "ECONNABORTED") return "Request timed out — the server may be starting; try again.";
  return "Something went wrong. Try again.";
}
